import { supabase } from 'src/services/supabase-client';
import { Note } from '../types/note';

export const getNotes = async (): Promise<Note[]> => {
  return (
    (
      await supabase
        .from<Note>('notes')
        .select('id,title')
        .filter('deleted', 'eq', false)
        .order('order')
    ).data || []
  );
};
